import { runtimeEnv } from "config/runtimeEnv";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = runtimeEnv("B2B_API_BASE_URL");

export const serviceCityApi = async (payload) => {
  let url;
  if (payload?.contractId) {
    url = `${env}${API_ENDPOINT.ServiceCity.City}?contractId=${payload?.contractId}`;
  } else {
    url = `${env}${API_ENDPOINT.ServiceCity.City}`;
  }

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
